export const dargIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.50033 10.8337C7.96056 10.8337 8.33366 10.4606 8.33366 10.0003C8.33366 9.54009 7.96056 9.16699 7.50033 9.16699C7.04009 9.16699 6.66699 9.54009 6.66699 10.0003C6.66699 10.4606 7.04009 10.8337 7.50033 10.8337Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.50033 4.99967C7.96056 4.99967 8.33366 4.62658 8.33366 4.16634C8.33366 3.7061 7.96056 3.33301 7.50033 3.33301C7.04009 3.33301 6.66699 3.7061 6.66699 4.16634C6.66699 4.62658 7.04009 4.99967 7.50033 4.99967Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.50033 16.6667C7.96056 16.6667 8.33366 16.2936 8.33366 15.8333C8.33366 15.3731 7.96056 15 7.50033 15C7.04009 15 6.66699 15.3731 6.66699 15.8333C6.66699 16.2936 7.04009 16.6667 7.50033 16.6667Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5003 10.8337C12.9606 10.8337 13.3337 10.4606 13.3337 10.0003C13.3337 9.54009 12.9606 9.16699 12.5003 9.16699C12.0401 9.16699 11.667 9.54009 11.667 10.0003C11.667 10.4606 12.0401 10.8337 12.5003 10.8337Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5003 4.99967C12.9606 4.99967 13.3337 4.62658 13.3337 4.16634C13.3337 3.7061 12.9606 3.33301 12.5003 3.33301C12.0401 3.33301 11.667 3.7061 11.667 4.16634C11.667 4.62658 12.0401 4.99967 12.5003 4.99967Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5003 16.6667C12.9606 16.6667 13.3337 16.2936 13.3337 15.8333C13.3337 15.3731 12.9606 15 12.5003 15C12.0401 15 11.667 15.3731 11.667 15.8333C11.667 16.2936 12.0401 16.6667 12.5003 16.6667Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Chevron = ({ up = false }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d={up ? "M7 14l5-5 5 5" : "M7 10l5 5 5-5"}
      stroke="white"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.95"
    />
  </svg>
);

export const pauseIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.75 3H11.25C10.8358 3 10.5 3.33579 10.5 3.75V14.25C10.5 14.6642 10.8358 15 11.25 15H12.75C13.1642 15 13.5 14.6642 13.5 14.25V3.75C13.5 3.33579 13.1642 3 12.75 3Z"
      fill="white"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.75 3H5.25C4.83579 3 4.5 3.33579 4.5 3.75V14.25C4.5 14.6642 4.83579 15 5.25 15H6.75C7.16421 15 7.5 14.6642 7.5 14.25V3.75C7.5 3.33579 7.16421 3 6.75 3Z"
      fill="white"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const playIcon = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
    <path d="M8 5v14l11-7z" />
  </svg>
);
